module.exports = __webpack_public_path__ + "./assets/6-be94c9.bmp";


//////////////////
// WEBPACK FOOTER
// ./assets/6.bmp
// module id = 24
// module chunks = 0